
//avaialbel columns format 
// {
//     id : "username",
//     label:"Username / Account No",
//     type:"text" //text,select
//     options:[{value:"1",label:"1"}] //for select type
// }


import { useEffect, useState } from "react";
import SelectInput from "./SelectInput";
import SelectUser from "./SelectUser";
import SelectExchangeAndStock from "./SelectExchangeAndStock";
import SelectDatePicker from "./SelectDatePicker";
import LoadingSpinner from "../general/spinner/Loading";
import SelectInputDynamic from "./SelectInputDynamic";

interface Props {
    columns: Array<Columns>;
    onSearchSubmit: (input:object) => void;
    initSearchWhenReceived:any;
    loading?:Boolean;
}

interface Columns {
    map?: any;
    id?: string;
    label?: string;
    type: string;
    options?: Options[];
}

interface Options{
    value:any;
    label:any;
}

// }

const FilterInputBuilder = ({
    columns,
    onSearchSubmit,
    initSearchWhenReceived,
    loading = false
}:Props) => {
    // let columns =[
    //     {   
    //         id:"type",
    //         label:"Type",
    //         type:"select",
    //         options:[
    //             {value:"",label:"All"},
    //             {value:"Dividend",label:"Dividend"},
    //             {value:"Bonus issue",label:"Bonus issue"}
    //         ]
    //     },{
    //         type:"selectUser",
    //     }
    // ]
    const [doneInitSearch, setDoneInitSearch] = useState(false);
    const [inputValues, setInputValues] = useState<{ [key: string]: JSX.Element | null }>({});

    const onValueChange = (id:string, value:any) => {
        //console.log("onValueChange ",id,value)
   
        setInputValues(prevValues => ({
            ...prevValues,
            [id]: value
        }));
    }

    const onValuesChange = (values:any) => {
        setInputValues(prevValues => ({
            ...prevValues,
            ...values
        }));
       
    }
    
    useEffect(() => {
        if(initSearchWhenReceived && !doneInitSearch){
            checkInitSearch();
        }
    }, [inputValues]);

    

    //check if any of the initSearchWhenReceived is not empty
    const checkInitSearch = () => {
        if(!inputValues || Object.keys(inputValues).length === 0) return;
        let checkList = initSearchWhenReceived;
        let found = false;

        for (let key of checkList) {
            if (inputValues.hasOwnProperty(key)) {
                let value:any = inputValues[key] || "";
                if(value !== "" && value !== null && value !== undefined && value.length > 0){
                    found = true;
                }
            }
        }
       
        if(found){
            onSearchSubmit(inputValues);
            setDoneInitSearch(true);
        }
       
    }

    const onSearchButtonClick = () => {
        //console.log("onSearchSubmit ",inputValues)
       onSearchSubmit(inputValues);
    }



    return (
        <div>
            {
                columns && columns.map((col:any, i:number) => {
                    //use switch case for different types of input

                    switch(col.type){
                        case "select":
                            return <SelectInput key={i} {...col} onValueChange={onValueChange}/>
                        case "selectDynamic":
                            return <SelectInputDynamic key={i} {...col} onValueChange={onValueChange}/>
                        case "selectUser":
                            return <SelectUser key={i} {...col} onValuesChange={onValuesChange}/>
                        case "selectExchangeAndStock":
                            return <SelectExchangeAndStock key={i} {...col} onValueChange={onValueChange}/>
                        case "selectDateRangePicker":
                            return <SelectDatePicker key={i} {...col} onValueChange={onValueChange}/>
                        case "text":
                            return (
                                <div key={i}>
                                    <label>{col.label}</label>
                                    <input type="text" />
                                </div>
                            )
                    }
                    
                })
            }
            <div className="col-xxl-12 col-md-12 col-12 ">
                <div className="input-container ">
                    <div className="label"> </div>
                    <button
                        className="btn-primary-custom btn-md"
                        onClick={onSearchButtonClick}
                        style={{ width: '100%', maxWidth: '100%' }}
                    >
                        Search &nbsp;&nbsp;
                        
                        {
                            loading ?
                            <>
                                &nbsp;
                                <LoadingSpinner fontSize={19} color={"#fff"}/>
                            </>
                            :
                            <i
                                className="fas fa-chevron-right "
                                aria-hidden="true"
                            ></i>
                        }
                        
                    </button>
                </div>
            </div>
        </div>
    );
};
export default FilterInputBuilder;
